'use client'

import {
  MDXRemote,
  MDXRemoteSerializeResult,
  type MDXRemoteProps,
} from 'next-mdx-remote'
import {CH} from '@code-hike/mdx/components'
import mdxComponents from './mdx-components'
import {ShikiCode} from './shiki-code'

const defaultComponents = {
  CH,
  ShikiCode,
  ...mdxComponents,
}

/**
 * Renders compiled source from @skillrecordings/skill-lesson/markdown/serialize-mdx
 * with syntax highlighting and code-hike components.
 * @param {MDXRemoteSerializeResult} contents
 * @returns <MDXRemote components={components} {...contents} />
 */

const MDX = ({
  contents,
  components,
}: {
  contents: MDXRemoteSerializeResult
  components?: MDXRemoteProps['components']
}) => {
  return (
    <MDXRemote
      components={{...defaultComponents, ...components}}
      {...contents}
    />
  )
}

export default MDX
